module.exports = __webpack_public_path__ + "static/rankings-background-c2d9fed5d1b098f62f921ea88d6a14db.png";